<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='Tx_PurchasePlanConfirm' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white fh" id='txPurchasePlans-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else-if="item.key === 'planCode'">
                  <a class="link-type" @click.stop="openDrawer(scope.row,'txPurchasePlans')">{{scope.row.planCode}}</a>
                </span>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>

      <el-dialog class="dialog-mini" width="80%" title="计划平衡" :visible.sync="dialogVisible"
                 :close-on-click-modal="false" v-loading="dialogloading"
                 top="44px" v-el-drag-dialog>
        <el-row>
          <el-col>
            <el-table
              ref="PurchasePlanTable"
              :data="listPurchasePlan"
              height="400px"
              border fit highlight-current-row
              @row-click="listPurchasePlanrowClick"
              style="width: 100%">
              <el-table-column
                prop="planCode"
                label="申请单号"
                width="180">
              </el-table-column>
              <el-table-column
                prop="accName"
                label="公司"
                width="180">
              </el-table-column>
              <el-table-column
                prop="erpDeptName"
                label="请购部门"
                width="180">
              </el-table-column>
              <el-table-column
                prop="erpUser"
                label="请购人"
                width="180">
              </el-table-column>
              <el-table-column
                prop="typeMark"
                label="采购类型"
                width="180">
                <template slot-scope="scope">
                  <select-type ref="selectType" :isEdit="false" :typeId="'caitype'" v-model="scope.row.typeMark">
                  </select-type>
                </template>
              </el-table-column>
              <el-table-column
                prop="createUserName"
                label="制单人">
              </el-table-column>
              <el-table-column
                prop="remarks"
                label="备注">
              </el-table-column>
            </el-table>
          </el-col>
          <el-col>
            <el-table
              ref="PlanDetailTable"
              :data="planDetail"
              height="400px"
              border fit highlight-current-row
              style="width: 100%">
              <el-table-column fixed type="selection" align="center" width="55"></el-table-column>
              <el-table-column
                fixed
                prop="invCode"
                label="存货编码"
                min-width="100">
              </el-table-column>
              <el-table-column
                fixed
                prop="cInvName"
                label="存货名称"
                min-width="100">
              </el-table-column>
              <el-table-column
                fixed
                prop="cInvStd"
                label="规格型号"
                min-width="100">
              </el-table-column>
              <el-table-column
                fixed
                prop="invConfirmCount"
                label="确认数量"
                min-width="180">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.invConfirmCount"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                fixed
                prop="isPurchase"
                label="是否采购"
                min-width="120">
                <template slot-scope="scope">
                  <select-type :isEdit="true" :typeId="'TrueOrFalse'" v-model="scope.row.isPurchase">
                  </select-type>
                </template>
              </el-table-column>
              <el-table-column
                prop="attr"
                label="附件"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="handleUsers"
                label="采购员"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="cComUnitName"
                label="集采计量单位"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="linkcInvCode"
                label="ERP存货编码"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="linkcInvName"
                label="ERP存货名称"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="linkcInvStd"
                label="ERP规格型号"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="cErpComUnitName"
                label="ERP计量单位"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="groupType"
                label="计量单位组类别"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="changeRate"
                label="换算率"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="invTaxRate"
                label="税率"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="projName"
                label="项目"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="projCode"
                label="项目编码"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="invCount"
                label="数量"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="needDate"
                label="需求日期"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="venName"
                label="供应商"
                min-width="150">
              </el-table-column>
              <el-table-column
                prop="remarks"
                label="备注"
                min-width="150">
              </el-table-column>
              <el-table-column v-for="(item,index) in accList" :key="index" :label="item.accName">
                <el-table-column
                  label="可用量">
                  <template slot-scope="scope">
                  <span>
                    {{ scope.row.stockDetail.find(u => u.accGuid === item.accountId).canUse }}
                  </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="现存量">
                  <template slot-scope="scope">
                  <span>
                    {{ scope.row.stockDetail.find(u => u.accGuid === item.accountId).accStock }}
                  </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="未领料量">
                  <template slot-scope="scope">
                  <span>
                    {{ scope.row.stockDetail.find(u => u.accGuid === item.accountId).unUse }}
                  </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="未入库量">
                  <template slot-scope="scope">
                  <span>
                    {{ scope.row.stockDetail.find(u => u.accGuid === item.accountId).unStore }}
                  </span>
                  </template>
                </el-table-column>
              </el-table-column>

            </el-table>
          </el-col>
        </el-row>
        <div slot="footer">
          <el-button size="mini" @click="dialogVisible = false">取消</el-button>
          <el-button size="mini" type="primary" @click="save()">确认</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import * as tx_purchaseplanconfirms from '@/api/tx_purchaseplanconfirms';
import mytable from '@/utils/crmtableFlowV2';

export default {
  name: 'txPurchasePlans',
  components: {},
  mixins: [mytable],
  data() {
    return {
      crmType: 'Tx_PurchasePlanConfirm',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: '',
        accName: '',
        eRPDeptName: '',
        planDetail: []
      },
      dialogVisible: false,
      listPurchasePlan: [],
      planDetail: [],
      dialogloading: false,
      rules: {}
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.initData.accName = this.currentAccName;
    if (this.accList) {
      const tempaccindex = this.accList.findIndex(u => u.accountId === this.initData.AccountId);
      if (tempaccindex > -1) {
        this.initData.eRPDeptName = this.accList[tempaccindex].erpDeptName;
        this.initData.eRPUser = this.accList[tempaccindex].erpUser;
      }
    }
    this.listQuery.AccountId = this.getAccountId();
  },
  methods: {
    getApi() {
      return tx_purchaseplanconfirms;
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnconfirm':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择要平衡的记录！',
              type: 'error'
            });
            return;
          }
          this.confirmEdit();
          break;

        case 'btncommit':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请最少提交一条记录',
              type: 'error'
            });
            return;
          }
          this.commit();
          break;
      }
    },
    confirmEdit() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      tx_purchaseplanconfirms.get(this.multipleSelection.map(u => u.id).join()).then((req) => {
        this.listPurchasePlan = req.result.listPurchasePlan.map(o => ({ ...o }));
        this.planDetail = req.result.planDetail.map(o => {
          return { ...o, ...{ isPurchase: o.isPurchase.toString() }};
        });
        this.dialogVisible = true;
        loading.close();
      }).catch((_) => {
        loading.close();
      });
    },
    listPurchasePlanrowClick(row) {
      const detailrows = this.planDetail.filter(u => u.planGuid === row.id);
      if (detailrows) {
        detailrows.forEach(item => {
          this.$refs.PlanDetailTable.toggleRowSelection(item);
        });
      } else {
        this.$refs.PlanDetailTable.clearSelection();
      }
    },
    save() {
      const submitdata = {
        listPurchasePlan: this.listPurchasePlan,
        planDetail: this.planDetail
      };
      this.dialogloading = true;
      tx_purchaseplanconfirms.Confirm(submitdata).then(req => {
        this.$message({
          message: '保存成功！',
          type: 'success'
        });
        this.dialogloading = false;
        this.dialogVisible = false;
        this.getList();
      }).catch((_) => {
        this.dialogloading = false;
      });
    },
    commit() {
      this.$confirm('是否确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const paramStr = this.multipleSelection.map(u => u.id).join(',');
        this.listLoading = true;
        tx_purchaseplanconfirms.Commit(paramStr).then(res => {
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.getList();
          this.listLoading = false;
        }).catch((_) => {
          this.listLoading = false;
        });
      }).catch(() => {
      });
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txPurchasePlans') {
        this.getApi().get(row.id).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'tx_purchaseplansview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txPurchasePlans-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}
</style>
